import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import Input from '../../Input';
import List from '../../lists/List';
import Heading from '../../Heading';

const Work = ({ id, event }) => {
  const path = `${id}.items`;
  const { t } = useTranslation();

  return (
    <section>
      <Input
        name="heading"
        label={t('builder.sections.heading')}
        path={`${id}.heading`}
      />

      <List hasDate path={path} event={event} titlePath="company" />
    </section>
  );
};

export function WorkHeading({ id }) {
  return <Heading id={id} />;
}

export default memo(Work);
